import merge from 'latest_modules/lodash/merge';
import axios from './common/axios';

export default {
  writeConfirm(params, callback) {
    const data = merge({ mode: 'confirm' }, params);
    return axios
      .post('/home/review/write', data)
      .then(function (res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  writeSubmit(params, callback) {
    const data = merge({ mode: 'submit' }, params);
    return axios
      .post('/home/review/write', data)
      .then(function (res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  delete(params, callback) {
    return axios
      .post('/home/review/delete', params)
      .then(function (res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  feedback(params, callback) {
    return axios
      .post('/home/review/feedback', params)
      .then(function (res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  }
};
